// If a server-side Pandoc v2 route is available, prefer calling it for best fidelity.

/**
 * Converts markdown text to a DOCX document
 * @param content - The markdown content to convert
 * @returns Promise<Blob> - The DOCX file as a blob
 */
export async function convertMarkdownToDocx(
  content: string,
  options?: { includeToc?: boolean }
): Promise<Blob> {
  const url = `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v2/services/markdown-to-docx`
  const resp = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ markdown: content, toc: options?.includeToc === true }),
  })
  if (!resp.ok) {
    const message = await resp.text()
    throw new Error(`Pandoc conversion failed: ${resp.status} ${message}`)
  }
  const blob = await resp.blob()
  return blob
}

export async function convertMarkdownToPdf(
  content: string,
  options?: { includeToc?: boolean }
): Promise<Blob> {
  const url = `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v2/services/markdown-to-pdf`
  const resp = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ markdown: content, toc: options?.includeToc === true }),
  })
  if (!resp.ok) {
    const message = await resp.text()
    throw new Error(`Pandoc PDF conversion failed: ${resp.status} ${message}`)
  }
  const blob = await resp.blob()
  return blob
}

/**
 * Parses markdown content into DOCX paragraphs
 * @param content - The markdown content
 * @returns Array of DOCX paragraphs
 */
// Fallback client-side docx generation was removed in favor of Pandoc API.
// If needed later, we can reintroduce the remark+docx mapping here.

/**
 * Parses inline formatting (bold, italic) from a line of text
 * @param text - The text to parse
 * @returns Array of TextRun objects
 */
// Intentionally minimal client module now that we rely on the backend Pandoc service.
